import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    // Signal to Google that this is a real 404, not a soft 404
    document.title = "404 – Page Not Found | EventShowcase";

    // Add noindex meta so Google doesn't index 404 pages
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-white">
      <p className="text-7xl font-black text-gray-100 select-none">404</p>
      <h1 className="text-2xl font-semibold text-gray-800 mt-4">Page Not Found</h1>
      <p className="mt-2 text-gray-500 max-w-md">
        The page <span className="font-mono text-sm bg-gray-100 px-2 py-0.5 rounded">{location.pathname}</span> does not exist or has been moved.
      </p>
      <div className="mt-8 flex gap-4">
        <Link
          to="/"
          className="px-6 py-2.5 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          Go to Homepage
        </Link>
        <Link
          to="/discover"
          className="px-6 py-2.5 border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
        >
          Browse Events
        </Link>
      </div>
    </div>
  );
}
